import { useMutation } from "@tanstack/react-query";
import { api } from "../documentation";

export const GET_FILE_KEY = "get_file";

export const useGetFile = () => {
    return useMutation({
        mutationKey: [GET_FILE_KEY],
        mutationFn: ({ id, filename }: { id: string; filename?: string }) => 
            api.GetFile(id, filename)
    });
};

